import React, { useEffect, useState } from "react";
import {
  Modal,
  Select,
  Button,
  InputNumber,
  DatePicker,
  Input,
  Form,
  Row,
  Col,
  Radio,
} from "antd";
import dayjs from "dayjs";
import { Controller } from "Controller/Controller";
import { Alert } from "components/Alert/Alert";
import { Rules } from "errorHandling/Rules";
const { Option } = Select;
const { TextArea } = Input;

const AddServiceModal = (props) => {
  const [form] = Form.useForm();
  const [createsService, setCreatesService] = useState({
    type: "membership",
    name: "",
    description: "",
    cost: 0,
    interval: "Monthly", // default value
    interval_count: 1, // default value
  });
  const [repeatType, setRepeatType] = useState("month");
  const [dayCount, setDayCount] = useState(1);
  const [weekCount, setWeekCount] = useState(1);
  const [monthCount, setMonthCount] = useState(1);
  const [yearCount, setYearCount] = useState(1);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCreatesService({
      ...createsService,
      [name]: value,
    });
  };

  useEffect(() => {
    let newInterval = "";
    let newCount = 1;
    switch (repeatType) {
      case "none":
        newInterval = "OneTime";
        newCount = 1;
        break;
      case "day":
        newInterval = "Daily";
        newCount = dayCount;
        break;
      case "week":
        newInterval = "Weekly";
        newCount = weekCount;
        break;
      case "month":
        newInterval = "Monthly";
        newCount = monthCount;
        break;
      case "year":
        newInterval = "Annual";
        newCount = yearCount;
        break;
      default:
        newInterval = "Monthly";
        newCount = 1;
    }
    setCreatesService((prev) => ({
      ...prev,
      interval: newInterval,
      interval_count: newCount,
    }));
  }, [repeatType, dayCount, weekCount, monthCount, yearCount]);

  const handleCloseAddService = () => {
    props.onCancel(true);
    form.resetFields();
    setCreatesService({
      name: "",
      description: "",
      cost: 0,
      interval: "Monthly",
      interval_count: 1,
    });
    setRepeatType("month");
    setDayCount(1);
    setWeekCount(1);
    setMonthCount(1);
    setYearCount(1);
  };

  const createService = async () => {
    const response = await Controller.CreateServiceList(createsService);
    if (response.status < 250) {
      Alert.openNotification(
        response.message ? response.message : "Successful",
        "success"
      );
      // setCreatesService({
      //   name: "",
      //   description: "",
      //   cost: 0,
      //   interval: "Monthly",
      //   interval_count: 1
      // });
      // setRepeatType("month");
      // setDayCount(1);
      // setWeekCount(1);
      // setMonthCount(1);
      // setYearCount(1);
      handleCloseAddService();
      props.onCancel(true);
    } else {
      Alert.openNotification(
        response.detail ? response.detail : "Error",
        "error"
      );
    }
  };

  return (
    <Modal
      title="Create New Service"
      open={props.open}
      footer={null}
      onCancel={handleCloseAddService}
    >
      <Form form={form} onFinish={createService}>
        <label className="formLabel">Service Name</label>
        <Form.Item
          name="name"
          value={createsService.name}
          rules={[
            { required: true, message: "This field is required" },
            { validator: Rules.validateName },
          ]}
        >
          <Input
            className={"inputs"}
            onChange={handleChange}
            type="text"
            name="name"
            placeholder="Service 1"
            value={createsService.name}
          />
        </Form.Item>

        {/* <label className='formLabel'>Cost</label>
        <Form.Item
          name="cost"
          rules={[{ required: true, message: 'This field is required' }]}
        >
          <InputNumber
            value={createsService.cost}
            name="cost"
            defaultValue={0}
            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
            style={{ width: "100%" }}
            onChange={(value) => {
              setCreatesService({
                ...createsService,
                cost: value
              });
            }}
          />
        </Form.Item> */}

        <label className="formLabel">Services Will Be Replenished:</label>
        <Form.Item
          name="repeat"
          rules={[{ required: true, message: "Please select a repeat option" }]}
        >
          <Radio.Group
            value={repeatType}
            onChange={(e) => setRepeatType(e.target.value)}
            style={{ display: "flex", flexDirection: "column" }}
          >
            {/* <Radio value="none" style={{ marginBottom: 8 }}>Don't repeat</Radio> */}
            <Radio value="day" style={{ marginBottom: 8 }}>
              Every{" "}
              <InputNumber
                min={1}
                value={dayCount}
                onChange={setDayCount}
                bordered={false}
                controls={false}
                disabled={repeatType !== "day"}
                style={{
                  width: "70px",
                  textAlign: "center",
                  borderBottom: "1px solid #000",
                  background: "transparent",
                }}
              />{" "}
              day
            </Radio>
            <Radio value="week" style={{ marginBottom: 8 }}>
              Every{" "}
              <InputNumber
                min={1}
                value={weekCount}
                onChange={setWeekCount}
                bordered={false}
                controls={false}
                disabled={repeatType !== "week"}
                style={{
                  width: "70px",
                  textAlign: "center",
                  borderBottom: "1px solid #000",
                  background: "transparent",
                }}
              />{" "}
              week
            </Radio>
            <Radio value="month" style={{ marginBottom: 8 }}>
              Every{" "}
              <InputNumber
                min={1}
                value={monthCount}
                onChange={setMonthCount}
                bordered={false}
                controls={false}
                disabled={repeatType !== "month"}
                style={{
                  width: "70px",
                  textAlign: "center",
                  borderBottom: "1px solid #000",
                  background: "transparent",
                }}
              />{" "}
              month
            </Radio>
            <Radio value="year" style={{ marginBottom: 8 }}>
              Every{" "}
              <InputNumber
                min={1}
                value={yearCount}
                onChange={setYearCount}
                bordered={false}
                controls={false}
                disabled={repeatType !== "year"}
                style={{
                  width: "70px",
                  textAlign: "center",
                  borderBottom: "1px solid #000",
                  background: "transparent",
                }}
              />{" "}
              year
            </Radio>
          </Radio.Group>
        </Form.Item>

        <label className="formLabel">Description</label>
        <Form.Item name="description">
          <TextArea
            name="description"
            value={createsService.description}
            onChange={handleChange}
            autoSize={{ minRows: 3, maxRows: 5 }}
            placeholder="Description..."
          />
        </Form.Item>

        <br />
        <div
          className="btnBox"
          style={{ display: "flex", justifyContent: "end", marginTop: "15px" }}
        >
          <Button onClick={handleCloseAddService} type="secondary">
            Close
          </Button>
          <Button
            htmlType="submit"
            type="primary"
            style={{ marginLeft: "5px" }}
          >
            Create
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddServiceModal;
